<template>
    <table-base :filter="filter"
                :headers="headers"
                :api-data="apiData"
                :sorting="sorting"
                :items-field="itemsField"
                :edit-page-name="editPageName"
                :api-method="apiMethod"
                :claim-name="claimName"
                :form-title="formTitle"
                :excel-title="excelTitle"
                :has-edit-page="hasEditPage"
                :table-form="oauthGrantForm"
                :refresh-key="refreshKey"
                :show-expand="false"
                :is-add-disabled="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                oauthGrantForm: () => import('../oauth/forms/OauthGrantForm'),
                headers: [
                    { text: 'Client Name', value: 'clientName' },
                    { text: 'Created At', value: 'createdAt', format: this.formatDateTime },
                    { text: 'Expires At', value: 'expiresAt', format: this.formatDateTime },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    oauthClients: [],
                    users: [],
                    items: []
                },
                sorting: [
                    { column: "createdAt", direction: "descending" },
                    { column: "oauthCode", direction: "ascending" },
                    { column: "userId", direction: "ascending" },
                    { column: "oauthClientId", direction: "ascending" },
                ],
                itemsField: 'oauthGrants',
                editPageName: 'oauthGrant',
                apiMethod: 'OauthGrants',
                claimName: 'OauthGrants',
                formTitle: 'Oauth Grant',
                excelTitle: 'Oauth Grants',
                hasEditPage: false,
            }
        },
    };
</script>
